const Decode = data => {
  return atob(data);
};

export default Decode;
